module.exports = __webpack_public_path__ + "media/images/products/cards/trade_dos_5_dias-357f6d1ef15e08cecb69fd99e9397ab2.png";